// Live plan prices and limits for the marketing pricing section, so an edit in
// the admin dashboard (Admin → Pricing) reaches this page without a rebuild.
// GET /api/v1/billing/plans is public. Any failure resolves to null and the
// section keeps its typed-in text: a marketing page must never come up blank
// because the API is down.
import { useEffect, useState } from 'react';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.jawabai.cloud';

// Marketing card id → plan id in billing.
const CARD_TO_PLAN = {
  trial: 'free_trial',
  starter: 'starter',
  pro: 'pro',
  business: 'business',
};

export function useLivePlans() {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    fetch(`${API_URL}/api/v1/billing/plans`, { signal: controller.signal })
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error(res.status))))
      .then((body) => {
        const byId = Object.fromEntries(
          (body?.data ?? []).map((p) => [p.id, p]),
        );
        const out = {};
        for (const [card, planId] of Object.entries(CARD_TO_PLAN)) {
          const p = byId[planId];
          if (p) {
            out[card] = {
              price: Number(p.price),
              maxAgents: Number(p.maxAgents),
              maxMessages: Number(p.maxMessages),
              // Plan features (Admin → Pricing): the card's lines after
              // agents/messages. Absent from an older API → typed-in copy.
              features: p.features ?? [],
              catalogue: body?.features ?? [],
            };
          }
        }
        setPlans(out);
      })
      .catch(() => {}); // keep the static copy
    return () => controller.abort();
  }, []);

  return plans;
}
